<template>
  <div class="app flex-row align-items-center" id="login-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="12 mt-3 content-header">
          <b-row class="text-center">
            <b-col xl="6" md="12" class="d-flex vnat-logo">
              <div class="logo">
                <img src="/img/logo_TC.png" alt="">
              </div>
              <div class="title border-title">
                <p class="MCST-title">MINISTRY OF CULTURE, SPORTS AND TOURISM</p>
                <p class="bold VNAT-title">VIETNAM NATIONAL ADMINISTRATION OF TOURISM</p>
              </div>
            </b-col>
            <b-col xl="6" md="12" class="d-flex certificate-block">
              <div class="logo logo-certificate">
                <img src="/img/icon_certificate.png" alt="">
              </div>
              <div class="title">
                <p class="certificate-title">COVID-19 Vaccination Certificate</p>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="12" class="">
          <div style="position: relative;">
            <b-card-group>
              <b-card
                no-body
                class="text-white d-md-down-none card-image"
                style="background: transparent; border: none; max-width: 555px;box-shadow: rgba(0, 0, 0, 0.2) 0px 20px 30px;"
              >
                <b-card-body
                  class="text-center video-intro"
                  style="padding: 0px;padding-right:0; position: relative;  "
                >
                  <div
                    style="position:relative;width:100%;height:100%;"
                  >
                    <!-- <img src="img/img_login.png" style="height: 100%; width: 100%; object-fit: cover; object-position: center;"> -->
                    <div class="header-slide">
                      <img src="img/header_slide.png" style="height: 100%; width: 100%; object-fit: cover; object-position: center;">
                    </div>
                    <div class="main-slide">
                      <b-carousel
                        id="slide"
                        :interval="3500"
                        style="text-shadow: 1px 1px 2px #333;"
                      >
                        <!-- Slides with image only -->
                        <b-carousel-slide img-src="img/slide1.png"></b-carousel-slide>
                        <b-carousel-slide img-src="img/slide2.png"></b-carousel-slide>
                      </b-carousel>
                    </div>
                    <div class="footer-slide">
                      <img src="img/footer_slide.png" style="height: 100%; width: 100%; object-fit: cover; object-position: center;">
                    </div>
                  </div>
                </b-card-body>
              </b-card>
              <b-card
                no-body
                class="card-content"
              > 
                <b-card-body style="padding: 0">
                  <div class="header-card d-flex-jc_c">
                    <h5
                      class="register-title"
                    >
                      REGISTER required to get LOGIN information
                    </h5>
                    <div class="btn-register">
                      <b-link class="button-register el-button el-button--success el-button--small" @click="register_click">
                        REGISTER
                      </b-link>
                    </div>
                  </div>
                  
                  <b-alert
                    variant="danger"
                    dismissible
                    :show="mData.dataDefault.showDismissibleAlert"
                    @dismissed="mData.dataDefault.showDismissibleAlert = false"
                    >{{ mData.dataDefault.error }}</b-alert
                  >

                  <el-form
                    :model="mData.dataForm"
                    :rules="mData.validForm"
                    ref="myForm"
                    label-width="100%"
                    label-position="top"
                    @submit.native.prevent
                  >
                    <el-form-item label="Username" prop="account">
                      <el-input
                        v-model.trim="mData.dataForm.account"
                        clearable
                      ></el-input>
                    </el-form-item>

                    <el-form-item label="Password" prop="password">
                      <el-input
                        v-model="mData.dataForm.password"
                        show-password
                      ></el-input>
                    </el-form-item>
                    <div class="login-block d-flex-jc_c mb-4">
                      <el-form-item label prop="remember">
                        <el-checkbox class="bold" v-model="mData.dataForm.remember">{{
                          'Remember login'
                        }}</el-checkbox>
                      </el-form-item>

                      <el-form-item class="text-center">
                        <el-button
                          class="btn-login"
                          type="primary"
                          @click="fn_submitForm()"
                          v-ladda
                          native-type="submit"
                          >{{ 'Login' }}</el-button
                        >
                      </el-form-item>
                    </div>
                  </el-form>
                  <b-col
                    md="12"
                    style="padding: 0;"
                  >
                    <div class="qr-block d-flex-jc_c d-flex-ai_fs mb-4">
                      <b-link to="/auth/forgotForeignerPassword" style="font-size: 14px;font-family: MYRIADPRO-REGULAR; color: #0c66ad;font-weight: 600;">Forgot your password</b-link>
                      <div class="qr">
                        <img src="img/qr.png" alt="">
                      </div>
                    </div>
                  </b-col>
                  <b-col md="12" style="padding: 0;">
                    <div class="contact-info">
                      <p class="phone">Phone number (Zalo/Viber/WhatsApp/Telegram): (+84) 906150276;</p>
                      <p class="email">Email: titc@vietnamtourism.gov.vn;</p>
                    </div>
                  </b-col>
                </b-card-body>
              </b-card>
            </b-card-group>
          </div>
        </b-col>
        <b-col md="12" class="text-center mt-4 mb-4">
          <h5
            class="title-footer"
          >
            WEBMASTER: TOURISM INFORMATION TECHNOLOGY CENTRE
          </h5>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
import ExtensionService from "../../service/ExtensionService";
import { YoutubeVue } from "youtube-vue";

export default {
  components: {
    YoutubeVue
  },
  data() {
    return {
      aLang: LanguageService.en,
      aExtension: ExtensionService,
      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false
        },
        dataForm: {
          account: "",
          password: "",
          remember: true
        },
        validForm: {
          account: [{
              required: true,
              message: LanguageService.en.valid_required,
              trigger: "blur"
          }],
          password: [{
              required: true,
              message: LanguageService.en.valid_required,
              trigger: "blur"
          }]
        }
      },
      isViewHdsdApp: false,
      isViewHdsdCsdvdl: false
    };
  },
  methods: {
    fn_submitForm() {
      this.$refs["myForm"].validate(valid => {
        if (valid) {
          AuthService.login(
            this.mData.dataForm.account,
            this.mData.dataForm.password,
            this.mData.dataForm.remember
          )
            .then(() => {
              this.$router.push({ name: "Admin-Home" });
            })
            .catch(() => {
              this.mData.dataDefault.showDismissibleAlert = true;
              this.mData.dataDefault.error = LanguageService.en.login_error;
            });
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    downloadFile(url, filename) {
      let downloadLink = document.createElement("a");
      downloadLink.href = url;
      if (filename) downloadLink.download = filename;
      // Firefox requires the link to be added to the DOM
      // before it can be clicked.
      downloadLink.onclick = function() {
        document.body.removeChild(downloadLink);
      };
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);

      downloadLink.click();
    },
    register_click() {
      sessionStorage.removeItem("foreignRegister");
      location.href = "/auth/travelpass-register";
    }
  },
  mounted: function() {}
};
</script>

<style scoped>
@font-face {
  font-family: UTM-Cafeta;
  src: url(/fonts/UTM_Cafeta.ttf);
}
@font-face {
  font-family: MYRIADPRO-REGULAR;
  src: url(/fonts/MYRIADPRO-REGULAR.OTF) format("opentype")  , url(/fonts/MYRIADPRO-REGULAR.woff) format("woff");
}
p{
  margin: 0;
}

.circle {
  display: block;
}

#login-page {
  position: relative;
  z-index: 4000;
  background-color: #e8eef2;
}
::v-deep .el-form-item__label {
  font-weight: 500;
  color: #0c66ad;
}
::v-deep .el-form-item__label:before{
  content: '' !important;
}
::v-deep .el-input__inner {
  border-radius: 12px;
  background-color: #f2f2f2;
  box-shadow: 0 0 3px rgba(51, 51, 51, 0.5);
  border: none;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #0c66ad;
  font-weight: 500;
}
::v-deep .certificate-block{
  padding-left: 13px;
  padding-right: 13px;
}
.header-card{
  margin-bottom: 20px;
  display: flex;
}
.d-flex{
  align-items: center;
  justify-content: center;
}
.d-flex-jc_c{
  justify-content: space-between;
}
.d-flex-ai_fs{
  align-items: flex-start;
}
.logo{
  max-width: 145px;
}
.title{
  color: #0c66ad;
  font-size: 14px;
}
.border-title{
  border-right: 2px solid #25b8ec;
  padding-right: 40px;
}
.vnat-logo{
  padding-right: 0;
}
.title .MCST-title{
  font-family: MYRIADPRO-REGULAR;
  font-size: 16px;
  letter-spacing: 1.3px;
}
.title .VNAT-title{
  font-family: MYRIADPRO-REGULAR;
  font-size: 17px;
}
.logo-certificate{
  margin-right: 20px;
}
.title .certificate-title{
  font-size: 40px;
  text-transform: uppercase;
  font-family: UTM-Cafeta;
}

.card-content {
  border-radius: 0; 
  max-width: 555px; 
  padding: 60px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 25px 60px;
}
.header-slide{
  position: absolute;
  top: 1px;
  max-width: 155px;
  right: 205px;
  z-index: 4;
}
.main-slide{
  position: absolute;
  top: 1px;
  left: 0;
  bottom: 97px;
}
.main-slide #slide{
  /* position: absolute;
  top: 1px;
  bottom: 97px; */
}
.footer-slide{
  position: absolute;
  bottom: 0.5px;
}
.register-title{
    font-size: 14px;
    color: rgb(12, 102, 173);
    margin-bottom: 10px;
    padding-top: 10px;
}
.button-register {
  text-decoration: none;
  padding: 10px 10px;
  width: 110px;
  font-size: 14px;
  border-radius: 10px;
  background-color: #0c66ad;
  border-color: #0c66ad;
}
.login-block{
  display: flex;
}
.btn-login{
  padding: 10px 10px;
  width: 110px;
  font-size: 14px;
  border-radius: 10px;
  background-color: #9e0b0f !important;
  border-color: #9e0b0f !important;
}
.btn-register:hover{
  background-color: #0c66ad !important;
  border-radius: 10px;
}
.qr-block {
  display: flex;
}
.qr{
  max-width: 110px;
}
.contact-info{
  font-family: MYRIADPRO-REGULAR;
  font-weight: 600;
  font-size: 14px;
}
.contact-info .phone{
  color: #9e0b0f;
}
.contact-info .email{
  color: #0c66ad;
}
.title-footer{
  color: black;
  margin-bottom: 5px;
  font-family: MYRIADPRO-REGULAR;
  font-weight: 500;
  font-size: 16px;
}
::v-deep .el-dialog__wrapper {
  background-color: #00000055;
}

::v-deep .el-dialog {
  margin-top: 20px !important;
  margin-bottom: 0;
  width: calc(100% - 40px) !important;
  height: calc(100% - 40px);
}

::v-deep .el-dialog__header {
  border: none;
  background: none;
  padding: 0;
}

::v-deep .el-dialog__headerbtn {
  top: 0px;
  right: 0;
  width: 55px;
  height: 55px;
  background-color: #ddd;
  font-size: 20px;
  border-bottom-left-radius: 4px;
  z-index: 2000;
}

::v-deep .el-dialog__body {
  height: 100%;
  padding: 0;
}

::v-deep .el-dialog__body iframe {
  margin: 0 auto;
  display: flex;
  width: 100%;
  height: calc(100% - 50px);
  border-width: 0;
  background-color: transparent;
  z-index: 1000;
  position: relative;
}

::v-deep .el-dialog__body .button-download-wrapper {
  padding-top: 10px;
}

@media screen and (min-width: 1820.98px) {

}

@media screen and (max-width: 1365px) {
  
}
@media screen and (max-width: 1199px) {
  .card-image {
    display: none;
  }
  .card-content {
    padding: 50px;
  }

  .container {
    max-width: 540px;
  }

  .content-header{
    margin-bottom: 20px;
  }

  .logo{
    max-width: 125px;
  }
  .border-title{
    border: none;
    padding :0;
  }
  .vnat-logo{
    padding-left: 0;
  }
}

@media screen and (max-width: 991px) {
  .card-image {
    display: none;
  }
}

@media screen and (max-width: 767px) {
  h3 {
    font-size: 16px;
  }
  h2 {
    font-size: 17px;
  }
  h5 {
    font-size: 14px;
  }
}
@media screen and (max-width: 540px) {
  .logo{
    max-width: 90px;
  }
  .title .MCST-title{
    font-size: 12px;
  }
  .title .VNAT-title{
    font-size: 13px;
  }
  .logo-certificate{
    max-width: 25px;
  }
  .title .certificate-title{
    font-size: 30px;
  }
  .header-card{ 
    display: block;
    text-align: center;
  }
}
@media screen and (max-width: 420px) {
  .card-content{
    padding: 30px;
  }
  .logo{
    max-width: 80px;
  }
  .title .MCST-title{
    font-size: 11px;
  }
  .title .VNAT-title{
    font-size: 12px;
  }
  .logo-certificate{
    max-width: 22px;
  }
  .title .certificate-title{
    font-size: 25px;
  }
  .header-card{ 
    display: block;
    text-align: center;
  }
  .contact-info .phone{
    font-size: 9.25px;
  }
  .contact-info .email{
    font-size: 9.25px;
  }
  .title-footer{
    font-size: 11.5px;
  }
}
@media screen and (max-width: 384px) {
  .card-content{
    padding: 30px;
  }
  .logo{
    max-width: 60px;
  }
  .title .MCST-title{
    font-size: 10px;
  }
  .title .VNAT-title{
    font-size: 11px;
  }
  .logo-certificate{
    max-width: 18px;
  }
  .title .certificate-title{
    font-size: 20px;
  }
  .header-card{ 
    display: block;
    text-align: center;
  }
  .register-title{
    font-size: 12px;
  }
  .login-block{
    display: block;

  }
  .qr-block {
    display: block;
    text-align: center;
  }
  .qr{
    margin: 0 auto;
    max-width: 150px;
  }
  .contact-info .phone{
    font-size: 9px;
  }
  .contact-info .email{
    font-size: 9px;
  }
  .title-footer{
    font-size: 11.5px;
  }
}
@media screen and (max-width: 346px) {
  .card-content{
    padding: 30px;
  }
  .logo{
    max-width: 55px;
  }
  .title .MCST-title{
    font-size: 8.5px;
  }
  .title .VNAT-title{
    font-size: 9.5px;
  }
  .logo-certificate{
    max-width: 18px;
  }
  .title .certificate-title{
    font-size: 20px;
  }
  .header-card{ 
    display: block;
    text-align: center;
  }
  .register-title{
    font-size: 11px;
  }
  .login-block{
    display: block;

  }
  .qr-block {
    display: block;
    text-align: center;
  }
  .qr{
    margin: 0 auto;
    max-width: 150px;
  }
  .contact-info .phone{
    font-size: 10px;
  }
  .contact-info .email{
    font-size: 10px;
  }
  .title-footer{
    font-size: 11px;
  }
}
</style>
